import { render, staticRenderFns } from "./ResponsibleInsuranceModal.vue?vue&type=template&id=1f0e5b74"
import script from "./ResponsibleInsuranceModal.vue?vue&type=script&lang=js"
export * from "./ResponsibleInsuranceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports